import { SvgIcon, SvgIconProps } from "@mui/material";

export const Marker = (props: SvgIconProps) => {
  return (
    <SvgIcon
      width="30"
      height="40"
      viewBox="0 0 30 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g id="Pin">
        <path
          id="Vector"
          d="M15 0C11.0234 0.00527509 7.21113 1.58732 4.39922 4.39922C1.58732 7.21113 0.00527509 11.0234 0 15C0 25.7688 13.975 39.2563 14.5687 39.825C14.6842 39.9373 14.8389 40 15 40C15.1611 40 15.3158 39.9373 15.4312 39.825C16.025 39.2563 30 25.7688 30 15C29.9947 11.0234 28.4127 7.21113 25.6008 4.39922C22.7889 1.58732 18.9766 0.00527509 15 0ZM15 21.875C13.6403 21.875 12.311 21.4718 11.1805 20.7164C10.0499 19.9609 9.16868 18.8872 8.64833 17.631C8.12798 16.3747 7.99183 14.9924 8.2571 13.6588C8.52238 12.3251 9.17715 11.1001 10.1386 10.1386C11.1001 9.17716 12.3251 8.52238 13.6588 8.2571C14.9924 7.99183 16.3747 8.12798 17.6309 8.64833C18.8872 9.16868 19.9609 10.0499 20.7164 11.1805C21.4718 12.311 21.875 13.6403 21.875 15C21.8739 16.823 21.1492 18.5711 19.8602 19.8602C18.5711 21.1492 16.823 21.8739 15 21.875Z"
          fill="#25B2B4"
        />
      </g>
    </SvgIcon>
  );
};
